module.exports = {
    props: {
        initPage: {
            default: 1
        },
        maxPages: {
            default: 10,
        },
        assessment:{
            required:true,
        },
    },
    data(){
        return{
            currentAnswered: 0,
            totalAssessmentQuestions:1,
        }
    },
    methods:{
        setUrlPageParameter(currentPage) {
            let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?page=' + currentPage;
            window.history.pushState({path: newurl}, '', newurl);
        },
        getCounterData(){
            axios.get(this.routes.counter).then(response=>{
                this.totalAssessmentQuestions = response.data.data.total;
                this.currentAnswered = response.data.data.count;
            }).catch(e=>console.log(e));
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/views/assessments/common/AssessmentMixins.js